import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

/**
 * A code from a shared "Tipsa en kompis" link (`/start?code=…`), kept while the friend signs up and
 * registers a group, so the create sale form can be filled in with it. Only kept in this browser session.
 */
type PendingBonusCodeStore = {
  code: string | null;
  setCode: (code: string | null) => void;
};

export const usePendingBonusCodeStore = create<PendingBonusCodeStore>()(
  persist(
    (set) => ({
      code: null,
      setCode: (code) => set({ code }),
    }),
    {
      name: 'piggo:pending-bonus-code',
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
);
